import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/quoting_/quotes/builder/$quoteId/task/$taskId",
)({
  beforeLoad: ({ params: { quoteId, taskId } }) => {
    throw redirect({
      to: "/quotes/$quoteId/tasks/$taskId",
      params: { quoteId, taskId },
      search: true,
    })
  },
})
